import { toastErrorFx, toastSuccessFx } from './model'

export const toast = {
    successFx: toastSuccessFx,
    errorFx: toastErrorFx,
}
